import type { ResponseWithType } from './types';
import type { ParticipantResultRest, ParticipantResults } from './types/participant-result.ts';

const participantResult = ({
  data,
}: ResponseWithType<ParticipantResultRest>): ParticipantResults => {
  return {
    results: data.results.map((result) => ({
      __typename: 'ParticipantResult',
      id: result.resultId,
      ...result,
    })),
  };
};

export default participantResult;
